import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaRegCircle, FaExclamationTriangle } from "react-icons/fa";
import SidebarItem from "./SidebarItem";

function LeftPanel({ title }) {
  const [selectedItem, setSelectedItem] = useState("");

  const siteItems = [
    { id: "en145", label: "EN 145 Fitzgerald Rd" },
    { id: "pad145", label: "PAD SITE 145 Fitzgerald Rd" },
    { id: "rear145", label: "Rear 145 Fitzgerald Rd" },
  ];

  // Set selected item based on title
  useEffect(() => {
    const normalized = title?.toLowerCase().trim();
    if (normalized === "dashboard") {
      setSelectedItem("dashboard");
    } else if (normalized === "reports") {
      setSelectedItem("report");
    } else {
      setSelectedItem("summary");
    }
  }, [title]);

  return (
    <div className="w-[20%] bg-[#002060] text-white flex flex-col py-6 px-0">
      {/* Header */}
      <div className="flex flex-col items-center mb-6">
        <h2 className="text-4xl text-[#98a5be]">{title}</h2>
        <hr className="border-t border-gray-600 w-full max-w-[13rem] mt-6" />
      </div>

      {/* Main Menu Items */}
      <div className="flex flex-col  text-[#7ABC32] font-semibold">
 
<SidebarItem
  id="home"
  label="HOME"
  selectedId={selectedItem}
  setSelectedId={setSelectedItem}
  to="/home"
  ClassName="text-[#7ABC32]"
/>

<SidebarItem
  id="report"
  label="REPORTS"
  selectedId={selectedItem}
  setSelectedId={setSelectedItem}
  to="/bulk-reporting"
/>
<SidebarItem
  id="dashboard"
  label="DASHBOARD"
  selectedId={selectedItem}
  setSelectedId={setSelectedItem}
  to="/dashboard"
/>
      </div>

      {/* Divider */}
      <div className="flex flex-col items-center my-2">
        <hr className="border-t border-gray-600 w-full max-w-[13rem] mt-4" />
      </div>

      {/* Sites */}
      <div className="flex flex-col  mt-4 ">
        <SidebarItem id="sites" className="text-[#7ABC32] font-semibold" label="SITES" selectedId={selectedItem} setSelectedId={setSelectedItem} />
        <SidebarItem id="blackstone"  className="text-gray-300" label="Blackstone Centre" selectedId={selectedItem} setSelectedId={setSelectedItem} />

        <SidebarItem
          id="waverley"
          label="Waverley Gardens"
          selectedId={selectedItem}
          setSelectedId={setSelectedItem}
          className="text-gray-300"
          icon={FaExclamationTriangle}
          iconClassName="text-white ml-[-1.5rem]"
        />

        <SidebarItem id="fitzgerald45" label="45 Fitzgerald Rd"  className="text-gray-300" selectedId={selectedItem} setSelectedId={setSelectedItem} />

        {siteItems.map((item) => (
          <SidebarItem
            key={item.id}
            id={item.id}
            label={item.label}
            selectedId={selectedItem}
            setSelectedId={setSelectedItem}
            className="text-gray-300"
            icon={FaRegCircle}
            iconClassName="text-[#7ABC32]"
          />
        ))}
      </div>
    </div>
  );
}

export default LeftPanel;
